import { Link } from '@tanstack/react-router'
import { Button } from '@bpinternal/ui-kit-next'

type Props = {
  workspaceId: string
  close: () => void
}

export const BotQuotaExceededDialog = ({ workspaceId, close }: Props) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2 self-end">
        <Button
          variant="secondary"
          onClick={() => {
            close()
          }}
        >
          Close
        </Button>
        <Link
          to="/workspaces/$workspaceId/billing"
          className="self-center"
          params={{ workspaceId }}
          onClick={() => {
            close()
          }}
        >
          <Button variant="default">Upgrade</Button>
        </Link>
      </div>
    </div>
  )
}
